import * as Yup from "yup";

export const CourseSchema = Yup.object().shape({
  title: Yup.string().required("The course's title is required"),
  language: Yup.string().required(
    "Please select the related language for the course"
  ),
  description: Yup.string().required("The course's description is required"),
});
export const ChapterSchema = Yup.object().shape({
  title: Yup.string()
    .required("Please provide the chapter title.")
    .min(5, "The chapter title must have at least 5 caractors."),
  language: Yup.string().required(
    "Please select the related language for the chapter."
  ),
  description: Yup.string().required("Provide the chapter description."),
});
export const LessonSchema = Yup.object().shape({
  language: Yup.string().required(
    "Please select the related language for the lesson."
  ),
  title: Yup.string()
    .required("Please provide the lesson's title.")
    .min(5, "The lesson's title must have at least 5 caractors."),
  type: Yup.string().required("Please specify the lesson's type."),
  accessibility: Yup.string().required(
    "Please specify the lesson's accessibility mode."
  ),
  // description: Yup.string().required("Provide the lesson's content."),
});
